import { PecaDetalhe3D } from './PecaDetalhe3D'

export function BarraLuzes3D({ y, z }: { y: number; z: number }) {
  return (
    <group name="barra-emergencia">
      <PecaDetalhe3D
        posicao={[0, y, z]}
        tamanho={[1.45, 0.07, 0.32]}
        cor="#29313a"
        raio={0.025}
      />
      {[-1, 1].map((lado) => (
        <PecaDetalhe3D
          key={lado}
          posicao={[lado * 0.48, y + 0.08, z]}
          tamanho={[0.42, 0.1, 0.28]}
          cor="#f44938"
          raio={0.035}
          rugosidade={0.2}
          realce={{ emissive: '#f44938', emissiveIntensity: 0.6 }}
        />
      ))}
      <PecaDetalhe3D
        posicao={[0, y + 0.08, z]}
        tamanho={[0.31, 0.1, 0.27]}
        cor="#edf1e9"
        raio={0.02}
        rugosidade={0.2}
      />
    </group>
  )
}

export function ChevronTraseiro3D({
  largura,
  altura,
  y,
  z,
}: {
  largura: number
  altura: number
  y: number
  z: number
}) {
  return (
    <group position={[0, y, z]} name="chevron-traseiro">
      <mesh>
        <planeGeometry args={[largura, altura]} />
        <meshStandardMaterial color="#c64b36" side={2} roughness={0.5} />
      </mesh>
      {[-1, 1].flatMap((lado) =>
        Array.from({ length: 4 }, (_, i) => (
          <mesh
            key={`${lado}-${i}`}
            position={[
              lado * largura * 0.25,
              -altura * 0.35 + i * altura * 0.23,
              -0.005,
            ]}
            rotation={[0, 0, lado * 0.3]}
          >
            <planeGeometry args={[largura * 0.46, altura * 0.09]} />
            <meshStandardMaterial color="#f2d968" side={2} roughness={0.45} />
          </mesh>
        )),
      )}
    </group>
  )
}

export function Persiana3D({
  lado,
  z,
  largura = 1.1,
}: {
  lado: number
  z: number
  largura?: number
}) {
  return (
    <group name="compartimento-equipamentos" position={[lado * 1.253, 1.54, z]}>
      <PecaDetalhe3D
        posicao={[0, 0, 0]}
        tamanho={[0.038, 1.23, largura]}
        cor="#35414a"
        raio={0.012}
      />
      <PecaDetalhe3D
        posicao={[lado * 0.027, 0, 0]}
        tamanho={[0.025, 1.12, largura - 0.08]}
        cor="#adb8bd"
        raio={0.008}
        metal={0.55}
      />
      {Array.from({ length: 7 }, (_, i) => (
        <mesh key={i} position={[lado * 0.043, -0.45 + i * 0.15, 0]}>
          <boxGeometry args={[0.007, 0.012, largura - 0.09]} />
          <meshStandardMaterial
            color="#74858e"
            metalness={0.5}
            roughness={0.5}
          />
        </mesh>
      ))}
      <PecaDetalhe3D
        posicao={[lado * 0.05, -0.45, 0]}
        tamanho={[0.035, 0.025, largura * 0.55]}
        cor="#d4dce0"
        raio={0.008}
        metal={0.75}
      />
    </group>
  )
}
